<template>
  <nav class="mobile-nav">
    <div class="mobile-nav__container">
      <div @click="toggleMenu" class="mobile-nav__icon" role="button" aria-pressed="false">
        <i class="fas fa-bars"></i>
      </div>

      <div @click="toggleMenu" class="mobile-nav__overlay" v-if="toggle"></div>

      <div v-if="toggle" class="mobile-nav__navigation">
        <div class="mobile-nav__link-group">
          <ul class="mobile-nav__links-container">
            <div @click="toggleMenu" class="mobile-nav__toggle-off">
              <i class="fas fa-times"></i>
            </div>

            <!-- Links for main nav -->
            <li v-for="(link, i) in links" :key="i" class="mobile-nav__item">
              <router-link
                class="link link--grey"
                @click.native="toggleMenu"
                :to="link.to"
              >
                {{ link.label }}
              </router-link>
            </li>

            <li class="mobile-nav__item">
              <router-link
                class="link link--grey"
                @click.native="toggleMenu"
                to="/assets"
              >
                Mina tillgångar
              </router-link>
            </li>
          </ul>

          <!-- Links for admin page -->
          <ul v-if="checkIfAdmin()" class="mobile-nav__links-container mobile-nav__links-container--admin">
            <li
              :key="'admin_' + i"
              v-for="(admin_link, i) in admin_links"
              class="mobile-nav__item"
            >
              <span
                class="link link--grey"
                @click="setAdminView(admin_link.admin_view)"
              >
                {{ admin_link.label }}
              </span>
            </li>
          </ul>
        </div>

        <Button
          :msg="'Logga ut'"
          :class="'button--secondary'"
          :icon="'fas fa-sign-out-alt'"
          @click.native="signOut"
          to="/"
        />
      </div>
    </div>
  </nav>
</template>

<script>
import Button from '../elements/Button'
import { mapMutations } from 'vuex';
import { eraseCookie } from '../../services/cookie';

export default {
  name: 'MobileNav',
  props: [ 'user' ],
  components: {
    Button
  },
  data () {
    return {
      toggle: false,
      links: [
        { label: 'Start', to: '/' },
        { label: 'Hjärnorna bakom', to: 'https://pensionondemand.se/hjarnorna-bakom' },
        { label: 'Om Pension on Demand', to: 'https://pensionondemand.se/om-oss' },
      ],
      admin_links: [
        { label: 'Databasvy', admin_view: 'dataCollection' },
        { label: 'Min profil', admin_view: 'settings' },
      ]
    }
  },
  methods: {
    ...mapMutations(['setAdminView']),
    toggleMenu () {
      this.toggle = !this.toggle
    },
    checkIfAdmin () {
      return this.user.role === 'admin'
    },
    signOut() {
      eraseCookie('pod');
      location.reload();
    },
  }
}
</script>

<style lang="scss" scoped>
.mobile-nav {
  z-index: 100;

  &__icon {
    display: flex;
    margin-right: 1rem;
    font-size: 3rem;
    color: $green;
    cursor: pointer;
  }

  &__overlay {
    top: 0;
    right: 0;
    position: fixed;
    background-color: rgba(0, 0, 0, .7);
    width: 100vw;
    height: 100vh;
  }

  &__navigation {
    top: 0;
    right: 0;
    position: fixed;
    width: 100%;
    height: 100vh;
    background-color: #f2f2e7;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include breakpoints(small) {
      width: 70vh;
    }
  }

  &__links-container {
    list-style: none;
    padding: 0;
    margin: 0;

    li:nth-child(even) {
      background-color: #e8e8d3;
    }

    &--admin {
      li:nth-child(even) {
        background-color: #f2f2e7;
      }
      li:nth-child(odd) {
        background-color: #e8e8d3;
      }
    }
  }

  &__item {
    width: 100%;
    background-color: #f2f2e7;
    height: 5rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 30px;
  }

  &__toggle-off {
    display: flex;
    justify-content: flex-end;
    font-size: 2.5rem;
    margin: 20px 30px;
    cursor: pointer;
    transition: color .2s;
    width: 40px;

    &:hover {
      color: #3f3f3f;
    }
  }

  &__admin {
    width: 100%;
  }

  @include breakpoints(xLarge) {
    display: none;
  }
}
</style>